define('helperContent-cloneEntity',[],function() {
    'use strict';

    var cloneEntity = function(entity) {
        var res = {},
            prop = null,
            layout = null;

        if (entity && entity.hasOwnProperty('contentEntity')) {
            prop = entity.contentEntity;

            layout = (prop.layout) ? prop.layout : null;

            res = {
                'customCss': prop.customCss,
                'customUiTemplates': prop.customUiTemplates,
                'componentsJson': prop.componentsJson,
                'customJavascript': prop.customJavascript,
                'components' : prop.components,
                'answers': entity.answers.slice(0),
                'ID': entity.contentEntityId,

                'contentEntityId': entity.contentEntityId, // remove when everywhere rewritten

                'feedbacks': entity.feedbacks.slice(0),
                'questions': entity.questions.slice(0),
                'children': entity.children.slice(0),
                // 'childrens': entity.children.slice(0), // remove when everywhere rewritten
                'typeId': entity.typeId,
                'imageID': prop.imageId,
                'imagePosition': prop.imagePosition,
                'imageScaleMode': prop.imageScaleMode,

                'showTextAreaBackground': prop.showTextAreaBackground,

                'imageId': prop.imageId, // remove when removed from trainingVM

                'layout': layout,
                'parentId': prop.parentId,
                'displayMode': prop.displayMode,
                'dateModified': prop.dateModified,
                'freeTextAnswerId': prop.freeTextAnswerId,
                'naviTargetId': prop.naviTargetId,
                'leftColumnTitle': prop.leftColumnTitle,
                'rightColumnTitle': prop.rightColumnTitle,
                'showDontKnowOption': prop.showDontKnowOption,
                'answerScoreCaption': prop.answerScoreCaption,
                'answerNoOpinionCaption': prop.answerNoOpinionCaption,
                'maximumPoints': prop.maximumPoints,
                'maximumWords': prop.maximumWords,
                'passAlways': prop.passAlways,
                'passThreshold': prop.passThreshold,
                'passedFeedback': prop.passedFeedback,
                'failedFeedback': prop.failedFeedback,
                'enableMovingBackwards': prop.enableMovingBackwards,
                'completeDespiteResults': prop.completeDespiteResults,
                'requiresCompletion': prop.requiresCompletion,
                'taskCountToAsk': prop.taskCountToAsk,
                'taskCountToShow': prop.taskCountToShow,
                'canSubmitMultipleTimes': !!prop.canSubmitMultipleTimes,
                'correctAnswerFeedbackId': prop.correctAnswerFeedbackId,
                'hasCorrectAnswers': !!prop.hasCorrectAnswers,
                'incorrectAnswerFeedbackId': prop.incorrectAnswerFeedbackId,
                'requiresAnswer': !!prop.requiresAnswer,
                'shuffleTasks': !!prop.shuffleTasks,
                'skipFeedback': !!prop.skipFeedback,
                'content': prop.content,
                'text': prop.text,
                'name': prop.name,
                'title': prop.title
            };

        }

        return res;
    };

    return cloneEntity;

});

